import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';

import ShareButton from 'utils/ShareButton';
import QRCodeButton from 'utils/QRCodeButton';
import PlacardButton from 'utils/PlacardButton';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import OnboardingModal from './index';
import { ONBOARDING_ROUTES } from '../../../constants/Routes';


const ShareSurvey = ({ path, history, createdSurvey, setModalStatus }) => {
  const customSurvey = createdSurvey || { rewards: [] };
  let rewardList = customSurvey.rewards.map(reward => {
    return reward.title;
  });
  rewardList = rewardList || [];

  const [isVisible, toggleModal] = useState(path === ONBOARDING_ROUTES.STEP_THREE);

  useEffect(() => {
    setModalStatus(isVisible);
  }, [isVisible])

  const redirectToReports = () => {
    history.push(ONBOARDING_ROUTES.STEP_FOUR);
  }

  const handleContinue = () => {
    toggleModal(!isVisible);
    redirectToReports();
    setModalStatus(false);
  }

  return (
    <OnboardingModal
      isVisible={isVisible}
      handleContinue={handleContinue}
      buttonText={"Preview Survey's Report"}
    >
      <h2>That's it! You are ready to go</h2>
      <p>
        Don't forget to promote your survey. We have 3 quick and easy ways for you to do that
      </p>
      <hr align="left" className="subheading-divider"></hr>
      <div className="card p-3 styled-box-shadow">
        <div className="row">
          <div className="col-md-8">
            <p className="mb-0">
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              Share the survey link on social media or via Email
            </p>
          </div>
          <div className="col-md-4 d-flex justify-content-end align-items-center">
            <div className="onboarding-share-btn">
              <ShareButton
                id={customSurvey.id}
                url={`${process.env.REACT_APP_SURVEY_URL}/${customSurvey.survey_token}`}
                reward={rewardList}
                name={customSurvey.name}
                title="Share Link"
                icon
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card p-3 styled-box-shadow">
        <div className="row">
          <div className="col-md-8">
            <p className="mb-0">
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              Download the survey QR code and include it on your menus, receipts, and other printed materials.
            </p>
          </div>
          <div className="col-md-4 d-flex justify-content-end align-items-center">
            <div className="onboarding-share-btn">
              <QRCodeButton
                customSurvey={customSurvey}
                title="Get QR Code"
                icon
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card p-3 styled-box-shadow">
        <div className="row">
          <div className="col-md-8">
            <p className="mb-0">
              <FontAwesomeIcon icon="check-circle" className="text-success" />
              Print a ready-made promotional Placard that contains everything you need to get started right now!
            </p>
          </div>
          <div className="col-md-4 d-flex justify-content-end align-items-center">
            <div className="onboarding-share-btn">
              <PlacardButton
                customSurvey={customSurvey}
                title="Print Placard"
                icon
              />
            </div>
          </div>
        </div>
      </div>
    </OnboardingModal>
  );
};

ShareSurvey.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  setModalStatus: PropTypes.func.isRequired
};

export default ShareSurvey;



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modal/ShareSurvey.js